











































import { Integration, WebhookChannelDetails } from '@/types';
import {
  Vue,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component
export default class WebhookIntegration extends Vue {
  @Prop() private integrationDetails!: WebhookChannelDetails;

  @Getter private hasPermission: any;

  private headers: Array<{ key: string, value: string, hasError: boolean }> = [];

  private mounted() {
    this.parseHeaders();
  }

  private parseHeaders() {
    this.headers = [];
    if (this.integrationDetails.headers) {
      Object.keys(this.integrationDetails.headers).forEach((key: string) => {
        let matchingHeader = null;
        if (this.headers && this.headers.length) {
          matchingHeader = this.headers.find((header: any) => String(header.key).toLowerCase() === key.toLowerCase());
        }
        this.headers.push({ key, value: this.integrationDetails.headers[key], hasError: matchingHeader ? matchingHeader.hasError : false });
      });

      if (this.headers.length === 0) {
        this.headers.push({ key: '', value: '', hasError: false });
      }
    }
  }

  private mapHeaders() {
    const headersMap: {[key: string]: string} = {};
    this.headers.forEach((header: { key: string, value: string }) => {
      if (header.key !== '') {
        headersMap[header.key] = header.value;
      }
    });
    return headersMap;
  }

  private updateChannelDetails() {
    this.$emit('update:detail', {key: 'headers', value: this.mapHeaders()});
  }

  private addHeader() {
    this.headers.push({ key: '', value: '', hasError: false });
  }

  private removeHeader(index: number) {
    this.headers.splice(index, 1);
    this.updateChannelDetails();
  }

  // keys need to be unique
  private handleKeyChange(header: { key: string, value: string, hasError: boolean }, index: number, event: any) {
    const matchingHeaderIndex = this.headers.findIndex((h) => h.key.toLowerCase() === event.toLowerCase());
    if (matchingHeaderIndex !== -1 && matchingHeaderIndex !== index) {
      header.hasError = true;
    } else {
      header.key = event;
      if (header.hasError) {
        header.hasError = false;
      }
      this.updateChannelDetails();
    }
  }

  @Watch('integrationDetails', { deep: true, immediate: true })
  private onIntegrationDetailsChange(value: WebhookChannelDetails) {
    if (value.headers) {
      this.parseHeaders();
    }
  }

  @Watch('headers', { deep: true })
  private handleHeadersChange(headers: WebhookIntegration['headers']) {
    this.$emit('validate', !headers.some((h) => h.hasError));
  }
}
